import React, { Component } from 'react';
import { Line } from 'react-progress-bar.js'
import * as Questions from  './questions'

export const SubSectionDashboard = (props) => (
    <table className="table">
        <thead>
            <Header />
        </thead>
        <tbody>
            {
                props.tree.sections.map( (section, sectionOffset) => 
                    section.subSections.map( (subSection, subSectionOffset) => 
                        <Row 
                            key={`${sectionOffset}-${subSectionOffset}`}
                            section={section}
                            sectionOffset={sectionOffset}
                            subSection={subSection}
                            subSectionOffset={subSectionOffset}
                            />
                        ))
            }
        </tbody>
    </table>

)


const Header = (props) => (
    <tr>
        <th>
            Secção
        </th>
        <th>
            SubSecção
        </th>
        <th colSpan={2}>
            Resultado
        </th>
    </tr>
)



const Row = (props) => (
    <tr>
        {
            Questions.subSectionsInSection(props.section) >= 1 && props.subSectionOffset === 0 &&
                <td rowSpan={Questions.subSectionsInSection(props.section)}>
                    {props.section.title}
                </td>
                
        }
        <td>
            {props.subSection.title}
        </td>
        <td>
        <Line
            progress={props.subSection.score / props.subSection.maxScore}
            // text={'test'}
            options={ { color: Questions.colorStyle(props.subSection.score / props.subSection.maxScore), strokeWidth: 6, trailColor: '#ccc', trailWidth: 2}}
            initialAnimate={true}
            containerStyle={ { width: '12em', height: '2em'} }
            containerClassName={''} 
            />
        </td>
        <td>
            <span >
                {props.subSection.score}
                &nbsp;/&nbsp;
                {props.subSection.maxScore}
            </span>
        </td>
    </tr>
)


// WEBPACK FOOTER //
// ./src/SubSectionDashboard.jsx